import { IconButton, Tooltip } from '@material-ui/core';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AgGrid from '../../components/AgGrid/AgGrid';
import { http } from '../../utils/http';
import { columns } from './columns';
import CreateExcel from '../../class/CreateExcel';
import './ClubPage.scss';

class RegistroProvisional extends Component {
   state = {
      registrosProvisionales: [],
      loading: false,
   };

   async componentDidMount() {
      await this._getRegistrosProvisionales();
   }

   _getRegistrosProvisionales() {
      this.setState({ loading: true });
      http('/registro-provisional', 'GET', {})
         .then((res) => {
            if (res.data.isSuccess) {
               this.setState({ 
                  registrosProvisionales: res.data.data,
                  loading: false 
               });
            }
         })
         .catch((err) => {
            console.error(err);
            this.setState({ loading: false });
         });
   }

   _handleExportExcel() {
      const dataToExport = this.state.registrosProvisionales.map(registro => ({
         nombre: registro.nombre,
         apellido: registro.apellido,
         telefono: registro.telefono,
         correo: registro.correo,
         desarrollo: registro.desarrollo,
         oficina: registro.oficina,
         createdAt: new Date(registro.createdAt).toLocaleString('es-MX'),
      }));

      const excel = new CreateExcel('Registros-Provisionales', columns, dataToExport);
      excel.createDefaultExcel();
   }



   render() {
      return (
         <div className="Page">
            <div className="Page-header">
               <div className="header-title">
                  <h1>Registros provisionales</h1>
               </div>
               <div className="header-actions">
                  <Tooltip title="Refrescar" aria-label="Refrescar">
                     <IconButton onClick={() => this._getRegistrosProvisionales()}>
                        <i className="material-icons">refresh</i>
                     </IconButton>
                  </Tooltip>
                  <Tooltip title="Exportar a Excel" aria-label="Exportar a Excel">
                     <IconButton 
                        onClick={() => this._handleExportExcel()}
                        disabled={this.state.registrosProvisionales.length === 0}
                     >
                        <i className="material-icons">file_download</i>
                     </IconButton>
                  </Tooltip>
               </div>
            </div>
            <div className="Page-content">
               <AgGrid
                  rowData={this.state.registrosProvisionales}
                  columnDefs={columns}
               />
            </div>

         </div>
      );
   }
}

const mapStateToProps = (state) => ({});

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(RegistroProvisional);
